import React, { useContext } from 'react';
import { Stack, IconButton } from 'office-ui-fabric-react';
import { useSelector } from 'react-redux';

import { Props, Vehicle, VehicleDetailsPanelRenderFn } from './Video.types';
import { Styled } from './Video.styles';

import { context } from './context';
import { IRootState } from 'reducer';
import { ITransportType } from 'reducer/user';
import combineFullName from 'utils/combineFullName';
import { vehicleKeys } from './consts';
import {useBoolean} from "hooks/useBoolean";

export const VehicleInfoPanel: React.FC<Props> = () => {
  const { vehicle, toggleDetailsOpen } = useContext(context);

  const transporttypes = useSelector<IRootState, ITransportType[]>(
    (state) => state.user.transporttypes
  );

  if (!vehicle) return null;

  return (
    <Styled.VehicleInfoPanel>
      <IconButton onClick={toggleDetailsOpen} iconProps={{ iconName: 'cancel' }} />
      <Stack tokens={{ childrenGap: 16 }}>
        {Object.entries(vehicleKeys).map(([key, value]) => {
          return (
            <div>
              <Styled.PanelDataTitle>{value}</Styled.PanelDataTitle>
              <Styled.PanelDataString>
                {renderContentString(key as keyof typeof vehicleKeys, {
                  vehicle,
                  transporttypes,
                })}
              </Styled.PanelDataString>
            </div>
          );
        })}
      </Stack>
    </Styled.VehicleInfoPanel>
  );
};

const renderContentString: VehicleDetailsPanelRenderFn = (
  key,
  { transporttypes, vehicle }
) => {
  switch (key) {
    case 'model':
    case 'depotNumber':
    case 'branch':
    case 'gosNomer':
    case 'route':
      return vehicle[key] || ' - ';
    case 'driver':
      return combineFullName({
        last_name: vehicle.driverLastName,
        first_name: vehicle.driverFirstName,
        middle_name: vehicle.driverMiddleName,
      });
    case 'ttype':
      const ttype = transporttypes.find(
        ({ code }) => code === vehicle['routeType']
      );
      return ttype?.title || ' - ';
    default:
      return null;
  }
};
